function initmajeProductDialogs() {
    const majeDialogs = document.querySelectorAll("dialog[data-maje-modal]");
    
    majeDialogs.forEach(dialog => {
      const showBtn = dialog.previousElementSibling;
      const closeBtn = dialog.querySelector(".maje-product-modal__closeBtn");
  
      showBtn.addEventListener("click", () => {
        dialog.showModal();
        document.body.style.overflow = 'hidden';
      });
  
      closeBtn.addEventListener("click", () => {
        dialog.close();
        document.body.style.overflow = 'auto';
      });
  
      const prevModalBtn = dialog.querySelector('button.maje-product-modal__prev') || null;
      const nextModalBtn = dialog.querySelector('button.maje-product-modal__next') || null;
      
      
      
      const modalHistory = (arr, button) => {
          const index = [...arr].findIndex(element => element.getAttribute('data-maje-modal') === button.getAttribute('data-maje-modal'));
          if (index < 0) {
              button.setAttribute('hidden', true)
          } else {
              button.querySelector('span').textContent = arr[index].getAttribute('data-maje-modal-title')
          }
          return index;
      }
  
      const isPrevModal = modalHistory(majeDialogs, prevModalBtn);
      const isNextModal = modalHistory(majeDialogs, nextModalBtn);
      
      prevModalBtn.addEventListener("click", () => {
        if (isPrevModal >= 0) {
          majeDialogs[isPrevModal].showModal();
          dialog.close();
        }
  
      });
  
      nextModalBtn.addEventListener("click", () => {
        if (isNextModal >= 0) {
          majeDialogs[isNextModal].showModal();
          dialog.close();
        }
  
      });
  
    });
  }
  
  initmajeProductDialogs()
  